<template>
  <transition name="modal">
    <div class="modal-mask" :style="styleMask">
      <div class="modal-wrapper">
        <div class="modal-container" :style="styleContent">
          <div class="modal-header">
            <slot name="header">default header</slot>
          </div>
          <div class="modal-body" :style="styleBody">
            <slot name="body">default body</slot>
          </div>
          <div class="modal-footer">
            <slot name="footer">
              default footer
              <button class="modal-default-button" @click="$emit('close')">OK</button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'dialog',
  props: {
    styleContent: {
      default: '',
      type: String
    },
    styleBody: {
      default: '',
      type: String
    },
    styleMask: {
      default: '',
      type: String
    }
  }
}
</script>
<style>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
}

.modal-container {
  width: 300px;
  margin: 70px auto;
  padding: 5px 10px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
}

.modal-header {
  padding: 10px 0 0 10px
}

.modal-body {
  margin: 20px 0;
}

.modal-body p{
  font-size: 12px;
}

.modal-default-button {
  float: right;
}
</style>




// WEBPACK FOOTER //
// src/components/Dialog.vue